import axios from 'axios'
import { AxiosApi } from './axiosApi'
import { configureBasicXAPI } from '../configuration/basicX'

export class BasicXAPI extends AxiosApi {
  constructor({ domain }: { domain: string }) {
    super(configureBasicXAPI(domain))
  }
}

export class BasicXHttpRequest extends AxiosApi {
  constructor() {
    super(axios)
  }
}
